import {observable} from 'mobx';
import {construct, ModelProperties} from 'utils';

export class SeqOffer {
    @observable id!: number;

    @observable url!: string;
    @observable enabled!: boolean;
    @observable data!: string;

    constructor(seqOffer?: ModelProperties<SeqOffer>) {
        if (seqOffer) {
            construct(this, seqOffer);
        }
    }
}